import { create } from 'zustand';

import { log } from '../utils/log';

type RateInfo = {
  rate: number;
  ts: number;
};

export type CurrencyRatesStore = {
  rates: Map<string, RateInfo>;
  getRate: (baseCurrency: string, quoteCurrency: string) => RateInfo | undefined;
  setRate: (baseCurrency: string, quoteCurrency: string, rateInfo: RateInfo) => void;
  clear: () => void;
};

const makeKey = (baseCurrency: string, quoteCurrency: string) => `${baseCurrency}/${quoteCurrency}`;
const LSK_CURRENCY_RATES = 'ooas_currency_rates_store';

export const useCurrencyRatesStore = create<CurrencyRatesStore>((set, get) => {
  let storedData: Map<string, RateInfo> = new Map();

  try {
    const data = localStorage.getItem(LSK_CURRENCY_RATES);
    if (data) {
      storedData = new Map(JSON.parse(data));
    }
  } catch (er) {
    log.warn('[useCurrencyRatesStore] init error');
  }

  return {
    rates: storedData,
    getRate: (baseCurrency, quoteCurrency) => {
      const rates = get().rates;
      return rates.get(makeKey(baseCurrency, quoteCurrency));
    },
    setRate: (baseCurrency, quoteCurrency, rateInfo) => {
      const curRates = get().rates;
      const newRates = new Map(curRates);

      newRates.set(makeKey(baseCurrency, quoteCurrency), rateInfo);

      // Serialize
      const data = JSON.stringify(Array.from(curRates));
      localStorage.setItem(LSK_CURRENCY_RATES, data);

      set({ rates: newRates });
    },
    clear: () => {
      localStorage.removeItem(LSK_CURRENCY_RATES);
      set({ rates: new Map() });
    },
  };
});
